import { render, staticRenderFns } from "./Hello.vue?vue&type=template&id=35fd1ff8&scoped=true&"
import script from "./Hello.vue?vue&type=script&lang=js&"
export * from "./Hello.vue?vue&type=script&lang=js&"
import style0 from "./Hello.vue?vue&type=style&index=0&id=35fd1ff8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fd1ff8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Benner\\Fontes\\RH\\Prod\\WES\\WebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35fd1ff8')) {
      api.createRecord('35fd1ff8', component.options)
    } else {
      api.reload('35fd1ff8', component.options)
    }
    module.hot.accept("./Hello.vue?vue&type=template&id=35fd1ff8&scoped=true&", function () {
      api.rerender('35fd1ff8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "content/components/example/Hello.vue"
export default component.exports